"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
function usePrescriptions(firestore, patientUid, country, firestoreHookOption, queryOptions) {
    const prescriptionsRef = (0, firestore_2.query)((0, firestore_2.collection)(firestore, `events/prescriptions/${country}`), (0, firestore_2.where)("uid", "==", patientUid));
    return (0, firestore_1.useFirestoreQuery)(keyFactory_1.FirestoreKeys.Prescriptions({
        name: "eventPrescriptions",
        path: `events/prescriptions/${country}`
    }, [patientUid, country]), prescriptionsRef, firestoreHookOption, {
        ...queryOptions,
        select: (order) => {
            const extendedOrders = [];
            order?.forEach(order => {
                const orderObject = order.data();
                extendedOrders.push({
                    ...orderObject,
                    status: orderObject.status,
                    id: order.id,
                });
            });
            return queryOptions?.select ? queryOptions.select(extendedOrders) : extendedOrders;
        }
    });
}
exports.default = usePrescriptions;
